import {translations} from 'presentation/translations-new';

const {cards} = translations['pt-br'].privateFlow.myHospitalization.generalOrientations;

export const ORIENTATION_CARDS = [
	{
		id: 1,
		title: cards.securityAndBiometrics.title,
		description: cards.securityAndBiometrics.line1,
	},
	{
		id: 2,
		title: cards.medicalBulletin.title,
		description: cards.medicalBulletin.line1,
	},
	{
		id: 3,
		title: cards.extendedVisit.title,
		description: cards.extendedVisit.line1,
	},
	{
		id: 4,
		title: cards.appMyHospitalization.title,
		description: cards.appMyHospitalization.line1,
	},
	{
		id: 5,
		title: cards.nutrition.title,
		description: cards.nutrition.line1,
	},
	{
		id: 6,
		title: cards.dischargeGuidelines.title,
		description: cards.dischargeGuidelines.topics.line1,
	},
	{
		id: 7,
		title: cards.visitingHours.title,
		description: cards.visitingHours.line1,
	},
];
